import { render, staticRenderFns } from "./PricePerPack.vue?vue&type=template&id=1368214e&"
import script from "./PricePerPack.vue?vue&type=script&lang=js&"
export * from "./PricePerPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports